import { render, staticRenderFns } from "./clientDetailsRow.vue?vue&type=template&id=db4c2e40&scoped=true&"
import script from "./clientDetailsRow.vue?vue&type=script&lang=js&"
export * from "./clientDetailsRow.vue?vue&type=script&lang=js&"
import style0 from "./clientDetailsRow.vue?vue&type=style&index=0&id=db4c2e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4c2e40",
  null
  
)

export default component.exports